import React, { Fragment } from 'react'
import styled, { css } from 'styled-components/macro'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withJob } from 'react-jobs'
import { createStructuredSelector } from 'reselect';
import { FormattedNumber } from '@dragonraider5/react-intl'
import { selectApplyByParamsId } from '../../selectors';
import { prop, theme } from 'styled-tools'
import CircularProgress from '../../../../components/CircularProgress'
import { em, rem, rgba } from '../../../../utils/styles'
import activitiesApi from '../../../Activities/api'

const renderValue = ({ value, format, suffix }) => (
  value ? (
    <Fragment>
      <FormattedNumber
        value={value}
        format={format}
      /> {suffix}
    </Fragment>
  ) : 'No disponible'
)

const Table = styled.table`
  width: 100%;
  border-spacing: 0;
  font-size: ${em(17)};
`
const cellStyles = css`
  border-bottom: 1px solid;
  text-align: ${prop('align', 'left')};
  padding: ${rem(12)} ${rem(16)};
  font-weight: ${theme('fontWeights.regular')};

  &:nth-child(2n) {
    font-weight: ${theme('fontWeights.bold')};
  }
  small {
    font-size: .75em;
  }
`
const Th = styled.th`
  ${cellStyles}
`
const Td = styled.td`
  ${cellStyles}
  &:not(:last-child) {
    border-right: 1px solid;
  }
`

const Source = styled.p`
  text-align: right;
  font-size: ${em(12)};
  color: ${rgba('base', 0.4)};
`

function SectorTable({ jobResult: sectorData }) {
  return (
    <Fragment>
      <Table>
        <thead>
          <tr>
            <Th></Th>
            <Th align='right'>Tu sector</Th>
            <Th>Conjunto de sectores</Th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <Th scope='row'>
              Volumen de ventas<br /> <small>(en millones de euros)</small>
            </Th>
            <Td align='right'>
              {renderValue({
                value: sectorData.sector.sales / 1000000,
                format: 'rounded'
              })}
            </Td>
            <Td>
              {renderValue({
                value: sectorData.average.sales / 1000000,
                format: 'rounded'
              })}
            </Td>
          </tr>
          <tr>
            <Th scope='row'>
              Crecimiento de ventas
            </Th>
            <Td align='right'>
              {renderValue({
                value: sectorData.sector.sales_growth,
                format: 'per'
              })}
            </Td>
            <Td>
              {renderValue({
                value: sectorData.average.sales_growth,
                format: 'per'
              })}
            </Td>
          </tr>
          <tr>
            <Th scope='row'>
              Número de empresas
            </Th>
            <Td align='right'>
              {renderValue({
                value: sectorData.sector.companies,
                format: 'rounded'
              })}
            </Td>
            <Td>
              {renderValue({
                value: sectorData.average.companies,
                format: 'rounded'
              })}
            </Td>
          </tr>
          <tr>
            <Th scope='row'>
              Evolución del nº de empresas
            </Th>
            <Td align='right'>
              {renderValue({
                value: sectorData.sector.companies_growth,
                format: 'per'
              })}
            </Td>
            <Td>
              {renderValue({
                value: sectorData.average.companies_growth,
                format: 'per'
              })}
            </Td>
          </tr>
          <tr>
            <Th scope='row'>
              Periodo medio de cobro
            </Th>
            <Td align='right'>
              {renderValue({
                value:sectorData.sector.payment_period,
                format: 'rounded',
                suffix: 'días'
              })}
            </Td>
            <Td>
              {renderValue({
                value:sectorData.average.payment_period,
                format: 'rounded',
                suffix: 'días'
              })}
            </Td>
          </tr>
          <tr>
            <Th scope='row'>
              Tasa de mora <small>(próximo trimestre)</small>
            </Th>
            <Td align='right'>
              {renderValue({
                value: sectorData.sector.unpayment_percent / 100,
                format: 'per'
              })}
            </Td>
            <Td>
              {renderValue({
                value: sectorData.average.unpayment_percent / 100,
                format: 'per'
              })}
            </Td>
          </tr>
        </tbody>
      </Table>
      <Source>Fuente: Banco de España, INE, CEPYME, INBONIS</Source>
    </Fragment>
  )
}

const mapStateToProps = createStructuredSelector({
  application: selectApplyByParamsId
})
const connector = connect(mapStateToProps)

const job = withJob({
  work: ({ application }) => new Promise(resolve => setTimeout(
    () => resolve(activitiesApi.getByCode(application.activity.sector)),
    750
  )),
  LoadingComponent: () => (
    <div style={{ textAlign: 'center', margin: '2em 0 0' }}>
      <CircularProgress size={60} />
    </div>
  )
})

export default compose(
  connector,
  job
)(SectorTable)
